import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import { useFormik } from 'formik'
import EmployeeContext from '@/product/context/employee/empContext'
import ReportContext from '@/product/context/report/reportContext'
import { handleRedirectInternal } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import CustomCommonContext from '@/custom/context/common/commonContext'
import '../Dashboard/Dashboard.css'
import { Button } from '@mui/material'
import AuthContext from '@/product/context/auth/authContext'

import EmployeeManage from './view'

const EmployeeView = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const employeeContext = useContext(EmployeeContext)
    const authContext = useContext(AuthContext)
    const history = useHistory()
    const reportContext = useContext(ReportContext)
    const { getAllExportDownload } = reportContext
    const {
        all_employees,
        changeUserStatus,
        getAllEmployees,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = employeeContext
    const { user } = authContext
    const customCommonContext = useContext(CustomCommonContext)
    const { allLocations } = customCommonContext
    const [changeStatus, setChangeStatus] = React.useState(false)
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    useEffect(() => {
        return () => setIsLoading(false)
    }, [])
    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : 'all'

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                action: {
                    value: action ? action.toString() : 'all',
                    type: 'in',
                    field: 'u.status',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_email,e.emp_firstname,e.emp_lastname',
                },
                emp_firstname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_firstname',
                },
                emp_lastname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_lastname',
                },
                emp_type: {
                    value: '',
                    type: 'in',
                    field: 'e.emp_type',
                },
                status: {
                    value: '',
                    type: 'in',
                    field: 'e.emp_status',
                },
                emp_location: {
                    value: [],
                    type: 'array',
                    field: 'e.emp_location',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllEmployees(values)
        },
    })

    useEffect(() => {
        if (all_employees) {
            setTableBody(
                all_employees.records.length ? all_employees.records : []
            )
        }
        setIsLoading(false)
    }, [all_employees])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.searchterm.value = ''
        formik.values.filters.emp_firstname.value = ''
        formik.values.filters.emp_lastname.value = ''
        formik.values.filters.emp_type.value = ''
        formik.values.filters.status.value = ''

        getAllEmployees(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    const onClickEdit = (id, type) => {
        handleRedirectInternal(history, `employees/edit/${id}`)
        // toggleFullScreenPopup(true, 'edit', id)
    }
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            user_id: '',
        },
        onSubmit: (values) => {
            if (
                values.action === 'active' ||
                values.action === 'deactivate' ||
                values.action === 'deactivated'
            ) {
                setIsLoading(true)
                changeUserStatus(values)
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.user_id = data
        if (
            action === 'active' ||
            action === 'deactivate' ||
            values.action === 'deactivated'
        ) {
            setChangeStatus(true)
        }
    }

    const tableValues = [
        {
            field: 'emp_firstname,emp_lastname',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Name',
            filterable: true,
            filterField: 'e.emp_firstname,e.emp_lastname',

            // secondaryClickID: 'user_id',
            // clickType: 'view',
        },
        // {
        //     field: 'emp_lastname',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Last Name',
        // },
        {
            field: 'emp_email',
            type: 'hyperlink',
            clickID: 'id',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Email',
            filterable: true,
            filterField: 'e.emp_email',
        },
        {
            field: 'emp_status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
            filterable: true,
            filterField: 'e.emp_status',
        },
        {
            field: 'emp_type',
            type: 'capitalize',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Type',
            filterable: true,
            filterField: 'e.emp_type',
        },
        // {
        //     field: 'action',
        //     type: 'button',
        //     clickType: 'edit',
        //     onclick: onClickEdit,
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Action',
        //     tooltipTitle: 'Edit employee',
        // },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Email / Name',
                placeholder: 'Enter Email Or Name ',
                class: 'col-sm-4 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-sm-auto col-12',
                type: 'text',
                name: 'emp_firstname',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-sm-auto col-12',
                type: 'text',
                name: 'emp_lastname',
                filter: true,
            },
            {
                label: 'Status',
                placeholder: 'Select Status',
                class: `col-sm-auto col-12`,
                type: 'select',
                options: [
                    {
                        show: 'Active',
                        value: 'active',
                    },
                    {
                        show: 'Deactivated',
                        value: 'deactivated',
                    },
                ],
                name: 'status',
                filter: true,
            },
            {
                label: 'Type',
                placeholder: 'Select Type',
                class: `col-sm-auto col-12`,
                type: 'select',
                options: [
                    {
                        show: 'Super Admin',
                        value: 'super_admin',
                    },
                    {
                        show: 'Admin',
                        value: 'admin',
                    },
                    {
                        show: 'Employee',
                        value: 'employee',
                    },
                ],
                name: 'emp_type',
                filter: true,
            },
            {
                label: 'Location',
                placeholder: 'Select Location',
                class: 'col-sm-6 col-12',
                type: 'multiselect',
                options: allLocations
                    ?.filter((location) => location.active === 1)
                    .map((location) => {
                        return {
                            value: String(location.id),
                            show: location.name,
                        }
                    }),
                name: 'emp_location',
                filter: true,
            },
        ],
    }

    const tableActions = []

    if (action === 'active') {
        tableActions.push({
            label: 'Move to De-activate',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactivated',
        })
    }
    if (action === 'deactivated') {
        tableActions.push({
            label: 'Move to Activate',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        })
    }

    if (action === 'all' || !action) {
        tableActions.push(
            {
                label: 'Move to De-activate',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
            },
            {
                label: 'Move to Activate',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            }
        )
    }

    const resetForm = () => {
        formik.values.filters.action.value = action
        formik.values.page = 1
        // formik.values.filters.searchterm.value = ''
        formik.values.filters.emp_firstname.value = ''
        formik.values.filters.emp_lastname.value = ''
        formik.values.filters.emp_type.value = ''
        formik.values.filters.status.value = ''
        getAllEmployees(formik.values)
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.status === 'success') {
                if (responseStatusUser.from === 'changeStatus') {
                    setChangeStatus(false)
                    getAllEmployees(formik.values)
                    console.log(formik.values, 'changeStatus')
                }
                if (responseStatusUser.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                    getAllEmployees(formik.values)
                    console.log(formik.values, 'employeeAction')
                }
            } else if (responseStatusUser.status === 'error') {
                if (responseStatusUser.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                }
            }
        }
    }, [responseStatusUser])

    return (
        <Layout>
            {' '}
            <div className="dashboard employeeManagement">
                {user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin' ? (
                    <div className="layoutTopHeader">
                        <div className="ltActions">
                            <Button
                                id="employee_add"
                                variant="outlined"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `employees/new/0`
                                    )
                                }
                            >
                                <span className="material-icons-round">
                                    post_add
                                </span>
                                Add New Employee
                            </Button>
                            <Button
                                id="employee_report"
                                variant="outlined"
                                className="exportDownload"
                                onClick={() =>
                                    getAllExportDownload({
                                        fields: [
                                            'emp_firstname',
                                            'emp_lastname',
                                            'emp_email',
                                            'emp_phone',
                                            'emp_address1',
                                            'emp_city',
                                            'emp_zip',
                                            'emp_state',
                                            'emp_country',
                                            'emp_type',
                                        ],
                                        action: 'export',
                                        isDefault: false,
                                        order: 'asc',
                                        orderby: '',
                                        search: 'all',
                                        report: `employee_list`,
                                    })
                                }
                            >
                                <span className="material-icons-round">
                                    get_app
                                </span>
                            </Button>
                        </div>
                    </div>
                ) : null}
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />

                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={all_employees}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllEmployees}
                    hideCompactView={true}
                />
            </div>
            <CustomDialog
                title={'Change user status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button
                        id="employee_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="employee_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <EmployeeManage data={manage} function={toggleFullScreenPopup} />
        </Layout>
    )
}

export default EmployeeView
